//@ts-check

class TenantService {
  constructor(
    $http,
    Utility,
    $timeout,
    $rootScope,
    LocalStorageService,
    InternalLinksService
  ) {
    this.$http = $http;
    this.Utility = Utility;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.LocalStorageService = LocalStorageService;
    this.InternalLinksService = InternalLinksService;

    this.init();
  }

  init() {
    this.InternalLinksService.getLinks('/api/tenant/links');
    this.friendlyUnitNames = [];
    this.tenant = {};
    this.noTenantForUnit = true;
  }

  async getTenantByCardCode(cardCode) {
    let promise, promiseHandler;

    try {
      promise = new Promise((resolve, reject) => {
        promiseHandler = {
          reject,
          resolve
        };
      });

      let {MasterProfileId} = this.LocalStorageService.retrieve('userProfile');
      let url = await this.InternalLinksService.getLink('GetTenantForUnit');
      if (!url) {
        await this.InternalLinksService.getLinks('api/tenant/links', false);
        url = await this.InternalLinksService.getLink('GetTenantForUnit');
      }

      url = `${url}?cardCode=${cardCode}&masterProfileId=${MasterProfileId}`;

      const headers = this.Utility.headersWithContentType;
      const results = await this.$http.get(url, { headers });
      this.tenant = results.data;

      if (!this.tenant) {
        this.noTenantForUnit = true;
      } else {
        const leaseStartDate = moment(this.tenant.LeaseEndDate).format(
          'YYYY/MM/DD'
        );
        this.tenant.LeaseStartDate =
          leaseStartDate === 'Invalid date' ? '' : leaseStartDate;

        const leaseEndDate = moment(this.tenant.LeaseEndDate).format(
          'YYYY/MM/DD'
        );
        this.tenant.LeaseEndDate =
          leaseEndDate === 'Invalid date' ? '' : leaseEndDate;
        this.noTenantForUnit = false;
      }

      this.$timeout(() => promiseHandler.resolve(this.tenant));
    } catch (error) {
      const msg = `Could not get friendly unit names.`;
      console.error(msg, error);
      this.$timeout(() => promiseHandler.reject(error));
    }

    return promise;
  }

  async registerTenant(tenant, cardCode) {
    const payload = {
      ...tenant,
      CardCode: cardCode
    };

    let promise, promiseHandler;
    tenant.CardCode = cardCode;

    try {
      promise = new Promise((resolve, reject) => {
        promiseHandler = {
          reject,
          resolve
        };
      });

      let url = await this.InternalLinksService.getLink(
        'RegisterTenantForUnit'
      );
      if (!url) {
        await this.InternalLinksService.getLinks('api/tenant/links', false);
        url = await this.InternalLinksService.getLink('RegisterTenantForUnit');
      }

      const headers = this.Utility.headersWithContentType;
      const results = await this.$http.post(url, payload, { headers });
      this.tenant = results.data;
      this.noTenantForUnit = false;
      this.$timeout(() => promiseHandler.resolve());
    } catch (error) {
      const msg = `Could not get friendly unit names.`;
      console.error(msg, error);
      this.$timeout(() => promiseHandler.reject(error));
    }

    return promise;
  }

  async deregisterTenant(id) {
    let promise, promiseHandler;

    try {
      promise = new Promise((resolve, reject) => {
        promiseHandler = {
          reject,
          resolve
        };
      });
      let url = await this.InternalLinksService.getLink(
        'DeregisterTenantForUnit'
      );
      if (!url) {
        await this.InternalLinksService.getLinks('api/tenant/links', false);
        url = await this.InternalLinksService.getLink(
          'DeregisterTenantForUnit'
        );
      }

      const headers = this.Utility.headersWithContentType;
      url = url.replace('{tenantId}', id);

      const results = await this.$http.post(url, id, { headers });
      this.tenant = {};
      this.noTenantForUnit = true;
      this.$timeout(() => promiseHandler.resolve());
    } catch (error) {
      const msg = `Could not deregister unit.`;
      console.error(msg, error);
      this.$timeout(() => promiseHandler.reject(error));
    }

    return promise;
  }

  extractUnitsFromUserProfile(user) {
    let cardCodes = [];

    if (
      user &&
      user.hasOwnProperty('BuildingProfiles') &&
      user.BuildingProfiles
    ) {
      user.BuildingProfiles.forEach(buildingProfile => {
        if (
          buildingProfile &&
          buildingProfile.hasOwnProperty('BuildingProfileUnit') &&
          buildingProfile.BuildingProfileUnit
        ) {
          buildingProfile.BuildingProfileUnit.forEach(unit => {
            cardCodes.push(unit.CardCode);
          });
        }
      });
    }

    return cardCodes;
  }
}
export default /* @ngInject */ (
  $http,
  Utility,
  $timeout,
  $rootScope,
  LocalStorageService,
  InternalLinksService
) =>
  new TenantService(
    $http,
    Utility,
    $timeout,
    $rootScope,
    LocalStorageService,
    InternalLinksService
  );
